<template>
  <div class="content-bg" style="margin-top:20px;">
    <div class="content" style="background: white">
      <div class="row">
        <div class="col-xs-3">
          <div class="left-nav">
            <ul>
              <li class="title">
                <a href="#">{{columnPidName}}</a>
              </li>
            </ul>
            <ul>
              <li v-for="(item,index) in childrenLsit" :key="index">
                <a
                  :class="num==item.id? 'newsytle':''"
                  href="javascript:;"
                  @click="getColumnDataInfo(item.id,item.templateType,item.label)"
                >{{item.label}}</a>
              </li>
            </ul>
          </div>
        </div>

        <div class="col-xs-9">
          <div class="index-middle" style="border: none">
            <div class="module-head" style="background: white">
              <span
                class="title"
                style="color: #0d4c99;font-size: 18px;width: 135px;text-align: left;margin-left:-490px"
              >{{columnName}}</span>
              <div class="he">
                <span style="color:#999999 ">>></span>
                <span>
                  <a class="hh" href="javascript:;" tppabs="http://www.gxlyzjz.cn/">首页</a>
                </span>
                <span style="color:#999999 ">>></span>
                <span>
                  <a class="hh">{{columnPidName}}</a>
                </span>
                <span style="color:#999999 ">>>></span>
                <span>
                  <a class="hh">{{columnName}}</a>
                </span>
              </div>
            </div>

            <div class="module-table-outer">
              <!-- 普通模板 -->
              <div v-if="templateTypeId==1">
                <ul class="news-list" style="width: 95%;margin: 0 auto;">
                  <li v-for="(item,index) in dataList" :key="index">
                    <a
                      @click="toDetails(item.id)"
                      :title="item.articleTitle"
                    >{{item.shortTitle?item.shortTitle:item.articleTitle}}</a>
                    <span class="tab-time">{{item.gmtCreate}}</span>
                  </li>
                </ul>
                <div class="pagination">
                  共{{totalCount}}条记录 {{queryParams.pageNum}}/{{totalPage}}页
                  &nbsp;
                  <a
                    @click="showDataInfo(1)"
                  >首页</a>
                  <a @click="showDataInfo(queryParams.pageNum==1?1:queryParams.pageNum-1)">上一页</a>&nbsp;
                  <a
                    @click="showDataInfo(queryParams.pageNum==totalPage?queryParams.pageNum:queryParams.pageNum+1)"
                  >下一页</a>
                  <a @click="showDataInfo(totalPage)">尾页</a>
                  &nbsp;第
                  <select
                    @change="showDataInfo(selectIndex)"
                    v-model="selectIndex"
                  >
                    <option
                      :value="index"
                      selected="selected"
                      v-for="index in totalPage"
                      :key="index"
                    >{{index}}</option>
                  </select>页
                </div>
              </div>
              <!--领导班子模板-->
              <div class="in_01c_c" v-if="templateTypeId==4">
                <div
                  class="row"
                  v-for="(item,index) in dataList"
                  :key="index"
                  style="height: 242px; border: 1px solid #cccccc"
                >
                  <div class="col-xs-3" style="background: #eeeeee; width: 22%">
                    <div class="photo">
                      <img :src="item.contentUrl" />
                    </div>
                  </div>
                  <div class="col-xs-9" style="width: 78%" v-html="item.content"></div>
                </div>
              </div>
              <!-- 简介模板 -->
              <div class="Dutytext" v-if="templateTypeId==3" v-html="content"></div>
              <!--仪器设备模板 -->
              <div v-if="templateTypeId==5">
                <div class="row" v-for="(item,index) in dataList" :key="index">
                  <div class="inst">
                    <div class="p-picture">
                      <img :src="item.contentUrl" width="120" height="120" />
                    </div>
                  </div>
                  <div class="col-xs-9" style="width: 85%">
                    <div class="newname">
                      <a
                        :title="item.articleTitle"
                        @click="toDetails(item.id)"
                      >{{item.articleTitle}}</a>
                    </div>
                    <p class="newline">{{item.articleTitle}}</p>
                  </div>
                </div>
              </div>
              <!--新闻动态模板-->
              <div v-if="templateTypeId==2">
                <div class="row" v-for="(item,index) in dataList" :key="index">
                  <div class="col-xs-3" style="background: #93ccf4;width:15%">
                    <div class="digital">
                      <p>
                        <span class="tab-time">{{fromMart(item.gmtCreate)}}</span>
                      </p>
                    </div>
                  </div>
                  <div class="col-xs-9" style="width: 85%">
                    <div class="newname">
                      <a
                        @click="toDetails(item.id)"
                        :title="formMartTitle(item.shortTitle==null?item.articleTitle:item.shortTitle)"
                        target="_blank"
                      >{{formMartTitle(item.shortTitle==null||item.shortTitle==''?item.articleTitle:item.shortTitle)}}</a>
                    </div>
                    <p class="newline">{{item.articleAbstract}}</p>
                  </div>
                </div>
                <div class="pagination">
                  共{{totalCount}}条记录 {{queryParams.pageNum}}/{{totalPage}}页
                  &nbsp;
                  <a
                    @click="showDataInfo(1)"
                  >首页</a>
                  <a @click="showDataInfo(queryParams.pageNum==1?1:queryParams.pageNum-1)">上一页</a>&nbsp;
                  <a
                    @click="showDataInfo(queryParams.pageNum==totalPage?queryParams.pageNum:queryParams.pageNum+1)"
                  >下一页</a>
                  <a @click="showDataInfo(totalPage)">尾页</a>
                  &nbsp;第
                  <select
                    @change="showDataInfo(selectIndex)"
                    v-model="selectIndex"
                  >
                    <option
                      :value="index"
                      selected="selected"
                      v-for="index in totalPage"
                      :key="index"
                    >{{index}}</option>
                  </select>页
                </div>
              </div>
              <!-- 互动交流 -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getDataInfo, getColumnList } from "@/api/content/column";
export default {
  data() {
    return {
      selectIndex: 1,
      //定义模板
      templateStyle01Begin:
        "<ul class='news-list' style='width: 95%;margin: 0 auto;'>",
      templateStyle01End: "",
      templateTypeId: 6,
      id: 0,
      num: 0,
      columnName: "",
      columnPidName: "",
      dataList: null,
      columnList: null,
      content: null,
      childrenLsit: null,
      //总页数
      totalPage: 10,
      //总条数
      totalCount: 0,
      //分页查询
      queryParams: {
        pageNum: 1,
        id: 0
      }
    };
  },
  created() {
    this.init();
  },
  watch: {
    //监听到路由（参数）改变
    $route(val, from) {
      // 拿到目标参数 val.query.id 去请求接口
      this.inits(val.query.id);
    }
  },
  methods: {
    init() {
      this.$root.num = this.$route.query.id;
      if (this.$route.query.pid != null) {
        this.$root.num = this.$route.query.pid;
      }

      this.content = "";
      this.queryParams.id = this.$route.query.id;
      this.num = this.queryParams.id;
      getDataInfo(this.queryParams).then(response => {
        this.dataList = response.rows;
        this.totalCount = response.total;
        this.totalPage = Math.ceil(this.totalCount / 10);
        if (this.dataList != null) {
          console.log("11");
          this.content = this.dataList[0].content;
        }
      });
      getColumnList(this.queryParams.id).then(response => {
        this.columnList = response.data;
        this.columnPidName = this.columnList.label;
        this.childrenLsit = this.columnList.children;
        this.childrenLsit.forEach(item => {
          if (item.id == this.queryParams.id) {
            this.templateTypeId = item.templateType;
            console.log(this.templateTypeId);
            this.columnName = item.label;
          }
        });
      });
    },
    inits(id) {
      console.log(this.$route.query.id);
      this.$root.num = this.$route.query.id;
      if (this.$route.query.pid != null) {
        this.$root.num = this.$route.query.pid;
      }
      this.content = "";
      this.queryParams.id = id;
      this.num = this.queryParams.id;
      getDataInfo(this.queryParams).then(response => {
        this.dataList = response.rows;
        this.totalCount = response.total;
        this.totalPage = Math.ceil(this.totalCount / 10);
        if (this.dataList != null) {
          this.content = this.dataList[0].content;
        }
      });
      getColumnList(this.queryParams.id)
        .then(response => {
          this.columnList = response.data;
          this.columnPidName = this.columnList.label;
          this.childrenLsit = this.columnList.children;
          this.childrenLsit.forEach(item => {
            if (item.id == this.queryParams.id) {
              this.templateTypeId = item.templateType;
              console.log(this.templateTypeId);
              this.columnName = item.label;
            }
          });
        })
        .catch(() => {
          this.templateTypeId = 6;
        });
    },
    toDetails(id) {
      this.$router.push({ path: "/Aitrcle/Details", query: { id: id } });
    },
    showDataInfo(index) {
      this.queryParams.pageNum = index;
      getDataInfo(this.queryParams).then(response => {
        this.dataList = response.rows;
        this.totalCount = response.total;
        this.totalPage = Math.ceil(this.totalCount / 10);
        if (this.dataList != null) {
          this.content = this.dataList[0].content;
        }
      });
    },
    formMartTitle(str) {
      if (str.length > 40) {
        return str.substring(0, 40) + "...";
      }
      return str;
    },
    fromMart(date) {
      if (date) {
        let newDate = /\d{4}-\d{1,2}-\d{1,2}/g.exec(date);
        console.log(newDate);
        const strAry = newDate[0].split("");
        strAry[newDate[0].indexOf("-")] = "   ";
        return strAry.join("");
      } else {
        return "";
      }
      const strAry = str.split("");
      strAry[str.indexOf("-")] = "   ";
      return strAry.join("");
    },
    getColumnDataInfo(id, templateType, label) {
      console.log(id, label);
      this.num = id;
      this.columnName = label;
      this.templateTypeId = templateType;
      this.content = "";
      this.queryParams.id = id;
      getDataInfo(this.queryParams).then(response => {
        this.dataList = response.rows;
        this.totalCount = response.total;
        this.totalPage = Math.ceil(this.totalCount / 10);
        if (this.dataList != null) {
          this.content = this.dataList[0].content;
        }
      });
    }
  }
};
</script>

<style scoped>
@import "../styles/home.css";
@import "../styles/pages.css";
@import "../styles/style.css";
.newsytle {
  color: red;
}
</style>


// WEBPACK FOOTER //
// src/components/Aitrcle.vue